module.exports = __webpack_public_path__ + "img/3.88e0fc28.png";